export default "__VITE_ASSET__mPsBe3o5__"